<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-form-field class="full-width">
    <!--suppress HtmlUnknownAttribute -->
    <textarea
      #commentEl
      matInput
      placeholder="{{ 'comments.comments-section.input-placeholder' | translate }}"
      formControlName="comment"
      rows="5"
      cdkFocusInitial
      [cdkTextareaAutosize]="false"
      [maxLength]="200"
      (keydown)="$event.ctrlKey && $event.code === 'Enter' ? submit() : undefined"
    ></textarea>
    <mat-hint align="end">{{ commentEl.value.length }} / 200</mat-hint>
    <button
      type="submit"
      [disabled]="!form.valid"
      class="comment-submit-button"
      mat-icon-button
      [matTooltip]="'shared.send' | translate"
      [attr.aria-label]="'shared.send' | translate"
      color="primary"
      [appLoadingButton]="submitPendingFlag.isPending()"
    >
      <mat-icon svgIcon="send_icon"></mat-icon>
    </button>
  </mat-form-field>
</form>
